/*
 Created by CHT 2020/10/11 10:56
 */

import BaseItem from '../BaseItem'
import {
  DATA_TYPE__ARRAY,
  DEFAULT_VALUE__ADDRESS,
  DEFAULT_VALUE__FILE,
  FORM_ITEM__ATTACHMENT,
  FORM_ITEM__TABLE
} from '../types'
import { defaultValueInit, uuid } from '../utils'

class Attachment extends BaseItem {
  constructor () {
    super()

    this.value = []

    this.uploadOneOnly = 0   // 只允许上传1个 0否 1是
    this.sizeLimit = 0 			 // 是否限制大小 0 否 1是
    this.limitSize = 500     // 限制上传大小 KB
    this.limitFileType = 0   // 是否限制文件类型
    this.fileTypes = []			 // 可选文件类型
    this.openWaterMark = "NO" //开启水印 YES NO
    //开启水印
    this.waterMarkConfig = {
      "position": "NorthWest", //水印位置
      "color": "", //颜色
      "fontSize": "S", //文本大小 小 S 中 M 大 L 特大 XL
      "dissolve": "100", //透明度，取值范围1-100，默认值100（完全不透明）。
      "content": ""
    }

    this.allowFileType = "NO" // 文件类型限制 NO 不限制 YES 限制文件类型
    this.fileTypeLimit = "" //限制的文件类型， 空字符串无限制

    this.defaultValue = {
      defaultType: ''
    }
  }

  get title () {
    return this.fieldTitle || Attachment._title
  }

  set title (val) {
    this.fieldTitle = val
    this.temTitle = val
  }

}

Attachment._title = '附件'
Attachment.use = true
Attachment.icon = 'iconfont icon-fujian'
Attachment.type = FORM_ITEM__ATTACHMENT

Attachment.prototype.type = Attachment.type
Attachment.prototype.dataType = DATA_TYPE__ARRAY
Attachment.prototype.defaultValueList = [
  {
    label: '不设置',
    value: {
      defaultType: ''
    }
  },
  {
    label: '自定义',
    value: defaultValueInit(DEFAULT_VALUE__FILE)
  }
]
Attachment.prototype.fileTypeList = [
  {
    label: '图片',
    value: 'image/*'
  },
  {
    label: '音频',
    value: 'audio/*'
  },
  {
    label: '视频',
    value: 'video/*'
  },
  {
    label: '文本文件',
    value: 'text/*'
  },
  {
    label: 'Word文档',
    value: '.doc, .docx'
  }
]
Attachment.prototype.filterOpts = [
  {
    name: '为空',
    method: 'empty'
  },
  {
    name: '不为空',
    method: 'not_empty'
  }
]
Attachment.prototype.createFileInfo = function (file) {
  return {
    fileName: file.name,          // 文件名称
    fileSize: (file.size / 1000).toFixed(2),   // 文件大小 KB
    fileUrl: '',                  // 地址
    fileType: file.type,          // 文件类型
    id: uuid('FILE')        // 前端使用
  }
}
Attachment.prototype.getValue = function () {
  return this.value
}
Attachment.prototype.setValue = function (val) {
  if (this.parent && this.parent.type === FORM_ITEM__TABLE) {
    return
  }
  this.value = val || []
}
Attachment.prototype.setConf = function (opts) {
  this.setBase(opts)
  if (opts.uploadOneOnly) this.uploadOneOnly = opts.uploadOneOnly
  if (opts.sizeLimit) this.sizeLimit = opts.sizeLimit
  if (opts.limitSize) this.limitSize = opts.limitSize
  if (opts.limitFileType) this.limitFileType = opts.limitFileType
  if (opts.fileTypes) this.fileTypes = opts.fileTypes
  if (opts.openWaterMark) this.openWaterMark = opts.openWaterMark
  if (opts.waterMarkConfig) this.waterMarkConfig = opts.waterMarkConfig
  if (opts.defaultValue) {
    this.defaultValue = opts.defaultValue
    if (opts.defaultValue.defaultType === DEFAULT_VALUE__FILE) {
      this.value = this.defaultValue.files
    }
  }
  // 文件类型是否限制
  if (opts.allowFileType) this.allowFileType = opts.allowFileType
  // 限制的文件类型
  if (opts.fileTypeLimit) this.fileTypeLimit = opts.fileTypeLimit
}
Attachment.prototype.getConf = function () {
  const base = this.getBase()
  return {
    ...base,
    uploadOneOnly: this.uploadOneOnly,
    sizeLimit: this.sizeLimit,
    limitSize: this.limitSize,
    limitFileType: this.limitFileType,
    fileTypes: this.fileTypes,
    openWaterMark: this.openWaterMark,
    waterMarkConfig: this.waterMarkConfig,
    defaultValue: this.defaultValue,
    // 文件类型是否限制
    allowFileType: this.allowFileType,
    // 限制的文件类型
    fileTypeLimit: this.fileTypeLimit
  }
}
Attachment.prototype.valueToString = function (value) {
  value = value || this.value
  return value.map(file => file.fileName).join('、')
}
export default Attachment
